// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2q61w","filesListContainer":"PosDisputesFiles_filesListContainer__3QWvh","filesButton":"PosDisputesFiles_filesButton__1m-xg"};